import clsx from "clsx";
import parse from "html-react-parser";

const LegacyContent = ({ content }) => {
  return !!content && (
    <div className={clsx("LegacyContent", "mb-15")}>
      <div className={clsx("LegecyContent__content", "prose")}>
        {parse(content)}
      </div>
    </div>
  );
};

export default LegacyContent;
